import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "ghost";

const VARIANTS: Record<Variant, string> = {
  primary: "bg-rose-600 text-white hover:bg-rose-500 active:bg-rose-700",
  secondary: "bg-teal-600 text-white hover:bg-teal-500 active:bg-teal-700",
  ghost: "bg-panel-raised text-neutral-200 hover:bg-panel active:bg-panel",
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export function Button({
  variant = "primary",
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      className={`cursor-pointer rounded-md px-3.5 py-1.5 text-sm font-semibold tracking-wide uppercase shadow-sm transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-400 disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[variant]} ${className}`}
      {...props}
    />
  );
}
